module.exports = __webpack_public_path__ + "static/media/thumb.ee6f72ff.jpg";